import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { MellanoLuukkuDrillStampPrintingView } from "src/tenantCustomizations/tenants/mellano/views/luukku/drillStamps/MellanoLuukkuDrillStampPrintingView.tsx";

export const Route = createFileRoute("/_authenticated/_shell/mellano/luukku/drillStamps")({
	staticData: { title: i18n.t("mellano_drill_stamps_title"), legacyViewKey: "mellanoLuukkuDrillStampPrintingPage" },
	component: RouteComponent,
});

function RouteComponent() {
	return <MellanoLuukkuDrillStampPrintingView />;
}
